var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelephone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_214_12)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.27315 7.05048L5.26226 6.86746L5.37226 6.72079L6.80645 4.80841L3.68015 0.640025L0.49977 2.30291C0.499778 2.3699 0.499841 2.43583 0.500004 2.48647V2.48807V3.35026C0.499998 4.94578 0.814258 6.52569 1.42484 7.99976C2.03541 9.47383 2.93035 10.8132 4.05855 11.9414C5.18676 13.0696 6.52614 13.9646 8.00021 14.5752C9.47428 15.1857 11.0542 15.5 12.6497 15.5L13.5119 15.5L13.5134 15.5C13.5641 15.5002 13.6301 15.5002 13.6971 15.5002L15.36 12.3198L11.1916 9.19359L9.27929 10.6278L9.13262 10.7378L8.94961 10.7269C7.99314 10.67 7.09073 10.2644 6.41321 9.58686C5.73568 8.90935 5.33007 8.00694 5.27315 7.05048Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_214_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.a6c1a64d.svg";
export { ForwardRef as ReactComponent };